<template>
  <div class="app c-app flex-row align-items-center">
    <div class="cover"></div>

    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="9">
          <CCardGroup>
            <CCard class="p-4 login-container register-container animated zoomIn faster">
              <CCardBody>

                <spinner-ttt :show="loading"></spinner-ttt>


                <CreditCardResponse
                  v-bind:show.sync="modalCreditCardResponse"
                  :title="creditErrorResponse ? 'Error al realizar el pago': 'Pago realizado correctamente'"
                  :confirmText="creditErrorResponse ? 'Inténtalo de nuevo': 'Continuar'"
                  :errorResponse="creditErrorResponse"
                  @cancel="modalCreditCardResponse = $event"
                  @confirm="modalCreditCardResponse = false"
                >
                  <template v-if="creditErrorResponse">
                    <h2>¡Oops!</h2>
                    <p>Algo ha ocurrido, error al realizar el pago. Inténtalo de nuevo o ponte en contacto con tu entidad bancaria</p>
                  </template>

                  <template v-else>
                    <h2>¡Listo!</h2>
                    <p>Pago confirmado</p>
                  </template>
                </CreditCardResponse>


                <CRow style="width: 100%;padding-bottom: 50px;margin-right: 0px; margin-left: 0px">
                  <div class="col-md-12" style="align-content: center;text-align: center;">
                    <img class="navbar-brand-minimized" src="logo/logo.png"  height="70" alt="MIMOTO - Área privada clientes MimoTo">
                  </div>
                </CRow>


              <template v-if="!creditErrorResponse">

                <div class="register-title mb-5 text-center">
                <h1 class="text-center">ENHORABUENA, EL PAGO SE HA REALIZADO CORRECTAMENTE</h1>
                </div>

                <div class="form-mimoto" style="color:#393939; margin-bottom: 20px;text-align:center"> 
                  <p class="datos-producto">¡Gracias por confiar en nosotros!</p>
                  <p class="datos-producto">Equipo de mimoTo</p>
                </div>

                <div v-if="addGTMdiv" id="iscardvalidated" :style="{ display: 'none' }">{{ true }}</div>

              </template>

              <template v-else>
                <div class="register-title mb-5 text-center">
                <h1 class="text-center">{{ title }}</h1>
                </div>

                <div class="form-mimoto" style="color:#393939; margin-bottom: 20px;"> 
                  <p class="datos-producto">Algo ha ocurrido, error al realizar el pago. Inténtalo de nuevo o ponte en contacto con tu entidad bancaria.</p>
                  <!-- <p class="datos-producto">¡Gracias por confiar en nosotros!</p>
                  <p class="datos-producto">Equipo de mimoTo</p> -->
                </div>
              </template>



                <p class="invalid-feedback d-block mt-0 mb-3" style="color: red;">
                  {{ message }}
                </p>

                <div v-if="!creditErrorResponse" class="title-container" >
                  <!-- <router-link to="/login">
                    <CButton color="link" class="px-0"> Acceder al área privada</CButton>
                  </router-link> -->

                  <button class="btn-login btn" @click="goTo">
                    Acceder al área privada
                  </button>

                </div>

                <div class="mt-4 text-center">
                  <span style="color: #7a7a7a;">&copy; {{new Date().getFullYear()}} mimoTo</span>
                </div>

                <div class="mt-4 logos-footer">
                  <img class="single-logo" :src="require('@/assets/img/logo-feder.png')" height="60" alt="">
                  <img class="single-logo" :src="require('@/assets/img/logo-ivace-gva.png')" height="50" alt="">
                  <img class="single-logo" :src="require('@/assets/img/sello-eu-75-1-r.png')" height="70" alt="">
                </div>  

                <!-- <div class="mt-4 terms-container legal">
                  <b>Información básica en protección de datos:</b>
                  Conforme al RGPD y la LOPDGDD, MIMOTO PARKING SL tratará los datos facilitados con la finalidad el servicio prestado. 
                  Siempre que nos lo autorice previamente, enviaremos información relacionada con la actividad ofrecida por MIMOTO PARKING SL. 
                  Podrá ejercer, si lo desea, los derechos de acceso, rectificación, supresión, y demás reconocidos en la normativa mencionada. 
                  Para obtener más información acerca de cómo estamos tratando sus datos, acceda a nuestra <a
                    class="link-terms" href="https://mimotoparking.com/politica-privacidad/" target="_blank">política de
                    privacidad.</a>
                </div> -->

              </CCardBody>

            </CCard>

          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>

    <toast ref="toast"></toast>
  </div>

</template>

<script>

import CreditCardResponse from '@/app/shared/components/modals/CreditCardResponse';

export default {
  name: 'TpvResponse',
  components:{ CreditCardResponse },
  data() {
    return {
      loading: false,
      status: '',
      message: null,
      error: false,
      modalCreditCardResponse: false,
      creditErrorResponse: false,
      title: '',

      addGTMdiv: false
    }
  },
  created() {
    document.title = 'mimoTo - Abono realizado';

  },
  async mounted() {

    if (this.$route.query.ok) {
      this.creditErrorResponse = false;
      this.modalCreditCardResponse = true;
      this.$refs.toast.showToast('Pago realizado correctamente', null,"success","5000");

      if(this.$route.query.vld) {
        this.addGTMdiv = true;

        this.$gtm.trackEvent({
          event: 'close_convert_lead',
          currency: "EUR",
          value: 1
        });
      }

      this.title = 'ENHORABUENA, EL PAGO SE HA REALIZADO CORRECTAMENTE';
    }


    if (this.$route.query.ko) {
      this.creditErrorResponse = true;
      this.modalCreditCardResponse = true;
      this.$refs.toast.showToast('Ha ocurrido un error al procesar el pago', null,"error","5000");

      // this.message = 'Error al realizar el pago';
      this.title = 'ERROR AL REALIZAR EL PAGO';
    }


  },
  computed: {

  },
  methods: {
    goTo(){
      this.$router.push('/login');
    }
  }

}
</script>


<style lang="scss" scoped>
@import '~@/assets/scss/mimoto.scss';

.app {
  width: 100%;
  background-image: url("~@/assets/img/login-background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  // margin-top: $header;
  position: relative;

  @media (min-width: 768px) {
    min-height: 100vh;
  }

  & > * {
    z-index: 2;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(#a8d7e7, 0.5);//#f3f6f9; #A6C4CE  2d5b83
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.9;
  }

  .register-title {
    font-family: $varela;
  }

}

.invalid-feedback {
  margin-top: 0.4rem !important;
}

.login {

  @media(max-width: 400px) {

    img {
      height:60px !important;

      display: flex;
      align-items: center;
      justify-content: center;

    }
  }

}

.register-footer-links {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #3899EC;
  font-family: "MuseoSans-300";
  font-size: 0.87rem;

  a:hover {
    color: #82C91E;
  }
}


.logos-footer {
  width: 100%;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 2rem;

  // display: flex;
  // justify-content: space-between;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }


  @media (max-width: 541px) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-gap: 2rem;
  }


  .single-logo {
    display: flex;
    justify-content: center;
    align-items: center;
  }

}

.datos-producto {
  font-size: 1.1rem;
}


</style>

